



















import { Component, Vue, Prop } from 'vue-property-decorator';
import VideoPlayer from '@/video/player/components/VideoPlayer.vue';
import Icon from '@/components/Icon.vue';

@Component({
  components: {
    Icon,
    VideoPlayer,
  },
})
export default class EngageVideo extends Vue {
  @Prop() id: string;
  @Prop() url: string;

  currentVideoPlayTime: number = null;

  handleClose() {
    this.sendTrackingData();
    this.$emit('close');
  }

  handleTimeUpdate(playtime: number): void {
    this.currentVideoPlayTime = playtime;
  }

  handlePause(): void {
    this.sendTrackingData();
  }

  handleEnded(): void {
    this.sendTrackingData();
  }

  sendTrackingData(): void {
    if (!this.currentVideoPlayTime) {
      return;
    }
    this.$emit('trackVideo', { id: this.id, viewDuration: this.currentVideoPlayTime });
    this.currentVideoPlayTime = null;
  }
}
